export default __webpack_public_path__ + "static/media/tab_push.2a59715e.mp3";